import router from '@/router'

export default () => {
  router.addRoute({
    path: '/apideck',
    name: 'apideckCallback',
    component: () => import('./apiDeck.Callback.vue')
  })
}
